import { sample } from 'effector';
import { $global } from 'models/store-global';

import { $qInstances } from '.';

import { createTunnel } from 'utils/factories/create-tunnel';

sample({
    source: createTunnel($global, (store) => store.qInstances || {}),
    target: $qInstances,
});
